import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.starts-with.js";
import Nl2br from 'vue-nl2br';
import Head from '~/assets/scripts/Head';
var AppHeader = function AppHeader() {
  return import('~/components/organisms/AppHeader');
};
var AppFooter = function AppFooter() {
  return import('~/components/organisms/AppFooter');
};
var Modal = function Modal() {
  return import('~/components/organisms/Modal');
};
var SignInModal = function SignInModal() {
  return import('~/components/organisms/SignInModal');
};
var InitTeamsModal = function InitTeamsModal() {
  return import('~/components/organisms/InitTeamsModal');
};
var AfterSignInModal = function AfterSignInModal() {
  return import('~/components/organisms/AfterSignInModal');
};
var ExternalSiteModal = function ExternalSiteModal() {
  return import('~/components/organisms/ExternalSiteModal');
};
var Tutorial = function Tutorial() {
  return import('~/components/templates/Tutorial');
};
var LoginModal = function LoginModal() {
  return import('~/components/organisms/LoginModal');
};
var UnsupportedNetworkModal = function UnsupportedNetworkModal() {
  return import('~/components/organisms/UnsupportedNetworkModal');
};
var REFERRAL_COOKIE_CODE = 'bfh:invite-code';
import { useCookie } from '@nuxt/bridge/dist/runtime';
import { useWalletStore } from '@/stores/useWalletStore';
import { useAuthStore } from '@/stores/useAuthStore';
import { useErrorStore } from '@/stores/useErrorStore';
export default {
  components: {
    Nl2br: Nl2br,
    AppHeader: AppHeader,
    AppFooter: AppFooter,
    Modal: Modal,
    SignInModal: SignInModal,
    AfterSignInModal: AfterSignInModal,
    InitTeamsModal: InitTeamsModal,
    ExternalSiteModal: ExternalSiteModal,
    Tutorial: Tutorial,
    LoginModal: LoginModal,
    UnsupportedNetworkModal: UnsupportedNetworkModal
  },
  data: function data() {
    return {
      device: 1,
      isLoading: true,
      isLogoShown: false,
      isLeadShown: false,
      isSignInButtonShown: false,
      isScrollIconShown: false,
      showIntroModal: false,
      selectedReplicaHero: {},
      viewedTutorials: [],
      stateMessage: this.$t('top.login.connection'),
      hasWalletConnect: false,
      walletStore: useWalletStore(),
      errorStore: useErrorStore(),
      web3: null,
      ewt: null,
      timerIds: []
    };
  },
  computed: {
    externalSite: function externalSite() {
      return useAuthStore().getExternalSite;
    },
    isSignInModalShown: function isSignInModalShown() {
      return useAuthStore().getIsSignInModalShown;
    },
    isError: function isError() {
      return useAuthStore().getIsError;
    },
    isExternalSiteModalShown: function isExternalSiteModalShown() {
      return useAuthStore().getIsExternalSiteModalShown;
    },
    networkName: function networkName() {
      return useAuthStore().getNetworkName;
    },
    me: function me() {
      return useUserStore().me;
    },
    isLoggedIn: function isLoggedIn() {
      return useAuthStore().isLoggedIn;
    },
    hasWallet: function hasWallet() {
      return useAuthStore().getHasWallet;
    },
    netId: function netId() {
      return useAuthStore().getNetId;
    },
    isUnsupportedNetwork: function isUnsupportedNetwork() {
      return useAuthStore().isUnsupportedNetwork;
    },
    isTutorial: function isTutorial() {
      return !useAuthStore().isUnsupportedNetwork && useAuthStore().isTutorial;
    },
    isAfterSignInModalShown: function isAfterSignInModalShown() {
      return useAuthStore().getIsAfterSignInModalShown;
    },
    isTop: function isTop() {
      if (!this.$route.name) {
        return false;
      }
      return this.isIndex && !this.isLoggedIn;
    },
    isIndex: function isIndex() {
      return this.$route.name.startsWith('index___');
    },
    isTouchDevice: function isTouchDevice() {
      if (process.server) return;
      return 'ontouchstart' in window;
    },
    isIos: function isIos() {
      return this.$device.isIos;
    },
    isMainnet: function isMainnet() {
      return useAuthStore().isMainnet;
    },
    platformName: function platformName() {
      if (process.server) {
        return '';
      }
      return this.$platform.name.toLowerCase();
    },
    lpLogo: function lpLogo() {
      var path = {
        ja: this.$env.staticUrl + '/lp/img/top/i_top_logo_BFH_JP.png',
        en: this.$env.staticUrl + '/lp/img/top/i_top_logo_BFH_EN.png'
      };
      return path[this.$i18n.locale];
    },
    loginGuide: function loginGuide() {
      var path = {
        ja: this.$env.staticUrl + '/lp/img/top/t_login_JP2.png',
        en: this.$env.staticUrl + '/lp/img/top/t_login_EN2.png'
      };
      return path[this.$i18n.locale];
    },
    aboutBCGImage: function aboutBCGImage() {
      var path = {
        ja: this.$env.staticUrl + '/lp/img/top/i_what_blockchain-game_JP.png',
        en: this.$env.staticUrl + '/lp/img/top/i_what_blockchain-game_EN.png'
      };
      return path[this.$i18n.locale];
    },
    socialLogin: function socialLogin() {
      var path = {
        ja: this.$env.staticUrl + '/lp/img/top/t_register_JP2.png',
        en: this.$env.staticUrl + '/lp/img/top/t_register_EN2.png'
      };
      return path[this.$i18n.locale];
    },
    appleStore: function appleStore() {
      var path = {
        ja: this.$env.staticUrl + '/lp/img/top/c_btn_appstore_JP.png',
        en: this.$env.staticUrl + '/lp/img/top/c_btn_appstore_EN.png'
      };
      return path[this.$i18n.locale];
    },
    googlePlay: function googlePlay() {
      var path = {
        ja: this.$env.staticUrl + '/lp/img/top/c_dtn_googleplay_JP.png',
        en: this.$env.staticUrl + '/lp/img/top/c_dtn_googleplay_EN.png'
      };
      return path[this.$i18n.locale];
    },
    howtostartBCGImage: function howtostartBCGImage() {
      var path = {
        ja: this.$env.staticUrl + '/lp/img/top/i_beggner_02.png',
        en: this.$env.staticUrl + '/lp/img/top/i_beggner_02_en.png'
      };
      return path[this.$i18n.locale];
    },
    ogpImageUrl: function ogpImageUrl() {
      if (this.$route.query.inviteCode) {
        if (this.$i18n.locale === 'ja') {
          return this.$env.staticUrl + '/referral/motto_tomodachi2_ja.jpg';
        } else {
          return this.$env.staticUrl + '/referral/motto_tomodachi2_en.jpg';
        }
      } else {
        return "".concat(this.$env.siteUrl, "ogp.png");
      }
    },
    ogpDescription: function ogpDescription() {
      if (this.$route.query.inviteCode) {
        return this.$t('common.meta.inviteDescription');
      } else {
        return this.$t('common.meta.description');
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var referralCookie;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.$route.query.inviteCode) {
              referralCookie = useCookie(REFERRAL_COOKIE_CODE);
              referralCookie.value = _this.$route.query.inviteCode;
            }
            _this.device = _this.isTouchDevice ? 2 : 1;
            _this.timerIds = [setTimeout(function () {
              return _this.isLogoShown = true;
            }), setTimeout(function () {
              return _this.isLeadShown = true;
            }, 1), setTimeout(function () {
              return _this.isSignInButtonShown = true;
            }, 2), setTimeout(function () {
              return _this.isScrollIconShown = true;
            }, 3)];
            _this.viewedTutorials = useCookie('mch:viewed-tutorials').value || [];
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.timerIds.forEach(function (id) {
      return clearTimeout(id);
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this2.isLoading = false;
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  methods: {
    toggleSignInModalShown: function toggleSignInModalShown() {
      useAuthStore().toggleSignInModalShown();
    },
    setExternalSite: function setExternalSite(obj) {
      useAuthStore().setExternalSite(obj);
    },
    refresh: function refresh() {
      location.reload();
    },
    handlePlayGameClick: function handlePlayGameClick() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var timerId;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.isLoading = true;
              if (!_this3.hasWalletConnect) {
                _context3.next = 7;
                break;
              }
              timerId = setTimeout(function () {
                _this3.walletStore.openWalletApp();
              });
              _this3.timerIds.push(timerId);
              _context3.next = 6;
              return _this3.signIn();
            case 6:
              return _context3.abrupt("return");
            case 7:
              _context3.next = 9;
              return _this3.walletStore.getWeb3;
            case 9:
              _this3.web3 = _context3.sent;
              _context3.next = 12;
              return _this3.walletStore.getEWT;
            case 12:
              _this3.ewt = _context3.sent;
              if (!(_this3.walletStore.providerType === 'metamask')) {
                _context3.next = 20;
                break;
              }
              _context3.next = 16;
              return _this3.walletStore.connect();
            case 16:
              _context3.next = 18;
              return _this3.signIn();
            case 18:
              _context3.next = 21;
              break;
            case 20:
              _this3.toggleSignInModalShown();
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    finishInitTeams: function finishInitTeams() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return useUserStore().fetchUser({
                uid: _this4.me.uid,
                force: true
              });
            case 2:
              useAuthStore().showTutorial();
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    showWeb3Modal: function showWeb3Modal() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this5.isLoading = true;
              _this5.toggleSignInModalShown();
              _context5.prev = 2;
              _this5.stateMessage = _this5.$t('top.login.connection');
              _context5.next = 6;
              return _this5.walletStore.connect();
            case 6:
              _this5.isLoading = false;
              _this5.hasWalletConnect = true;
              _context5.next = 13;
              break;
            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](2);
              _this5.errorStore.setError(String(_this5.$t('top.login.connectError')));
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[2, 10]]);
      }))();
    },
    signIn: function signIn() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this6.ewt.signAuth(_this6.$env.auth.redirectUri).then( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(auth) {
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!(auth !== null && auth !== void 0 && auth.state)) {
                          _context6.next = 5;
                          break;
                        }
                        _context6.next = 3;
                        return useAuthStore().signIn(auth.code);
                      case 3:
                        _context6.next = 6;
                        break;
                      case 5:
                        _this6.errorStore.setError(String(_this6.$t('top.login.connectError')));
                      case 6:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()).catch(function (e) {
                console.log(e);
                _this6.errorStore.setError(String(_this6.$t('top.login.connectError')));
              });
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    }
  },
  head: function head() {
    var head = new Head({
      title: this.$t('common.meta.title'),
      description: this.ogpDescription,
      url: this.$env.siteUrl,
      imageUrl: this.ogpImageUrl,
      ogType: 'website',
      twitterCardType: 'summary_large_image'
    });
    return head.get();
  }
};